
import { Vue, Component, Prop } from 'vue-property-decorator';
import { CombinationsConfiguratorFormData } from '@/interfaces/components/combinations/CombinationsConfiguratorFormData';

@Component({
    name: 'CombinationsProductTable',
})
export default class CombinationsProductTable extends Vue {
    @Prop({ type: Number, required: true }) readonly currentStep!: number;
    @Prop({ type: Array, required: true }) readonly tableHeaderFields!: any[];
    @Prop({ type: Array, required: true }) readonly productRowsFormData!: CombinationsConfiguratorFormData[];
    @Prop({ type: Array, required: true }) readonly productsSelectedForCombination!: number[];
    @Prop({ type: String, required: true }) readonly currentStepDescription!: string;

    private hasScrollbar = false;

    mounted() {
        this.checkScrollbar();
        // Watch for changes that might affect scrollbar
        this.$nextTick(() => {
            this.checkScrollbar();
        });
    }

    updated() {
        this.$nextTick(() => {
            this.checkScrollbar();
        });
    }

    private checkScrollbar() {
        const bodyElement = this.$el.querySelector('.combinations-product-table__body');
        if (bodyElement) {
            this.hasScrollbar = bodyElement.scrollHeight > bodyElement.clientHeight;
        }
    }

    private onToggleProductSelection(productId: number) {
        this.$emit('toggleProductSelection', productId);
    }

    private onUpdatePosition(productId: number, fieldPID: string, position: number) {
        this.$emit('updatePosition', { productId, fieldPID, value: position });
    }

    private getTableFields(row: CombinationsConfiguratorFormData) {
        return row.formData.filter((field) =>
            this.tableHeaderFields.some((header) => {
                return header.pid === field.fieldPID && field.segment === 'table';
            })
        );
    }

    private isRowSelected(productId: number): boolean {
        return this.productsSelectedForCombination.includes(productId);
    }
}
